import { render, staticRenderFns } from "./DirectReports.vue?vue&type=template&id=6dea1a86&scoped=true"
import script from "./DirectReports.vue?vue&type=script&lang=js"
export * from "./DirectReports.vue?vue&type=script&lang=js"
import style0 from "./DirectReports.vue?vue&type=style&index=0&id=6dea1a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dea1a86",
  null
  
)

export default component.exports